import { Component, Vue } from 'vue-property-decorator';
import { ProblemDocument } from 'http-problem-details';
import ProblemRendererHeaderComponent from '@/shared/problem-renderer/problem-render-header.vue';
import ProblemRendererBodyComponent from '@/shared/problem-renderer/problem-renderer-body.vue';
import { BUS_EVENTO } from '@/shared/bus-evento/bus-evento';

@Component({
  components: {
    'problem-renderer-header': ProblemRendererHeaderComponent,
    'problem-renderer-body': ProblemRendererBodyComponent,
  },
})
export default class ProblemAlerterComponent extends Vue {
  created() {
    BUS_EVENTO.$on('problem-detected', (prob: ProblemDocument, keyI18n: string, _delay = 1000) => {
      this.publish(prob, _delay);
    });
  }

  /**
   * Muestra un Problem al usuario
   */
  public publish(problem: ProblemDocument, _delay = 1000): void {
    const h = this.$createElement;
    this.$bvToast.toast(h('problem-renderer-body', { attrs: { value: problem } }), {
      title: [h('problem-renderer-header', { attrs: { value: problem } })],
      autoHideDelay: _delay,
      variant: 'danger',
    });
  }
}
